import React from 'react';
import cn from 'classnames';

import css from './style.module.scss';

const VipAvatar: React.FC = () => {
  return (
    <>
      <div className={cn(css.borderAvatar, css['borderAvatar--gold'])}></div>
      <div className={cn('absolute top-[-10%] left-[-15%] z-[5] w-[16px]')}>
        <img src="/img/VIP/vip.svg" alt="" />
      </div>
    </>
  );
};

export default VipAvatar;
